export default {
    namespaced: true,
    composite_alarm_rule: {
        title: "Regra de alarme composta",
        is_active: "Ativa",
        name: "Nome",
        description: "Descrição",
        type_alarm: "Tipo de alarme",
        alarm_level: "Nível de alarme",
        day_scope: "Dia de operação",
        evaluation_mode: "Modo de avaliação",
        start_time: "Hora de início",
        end_time: "Hora de término",
        created_at: "Criado em",
        updated_at: "Atualizado em",
        deleted: "Regra excluída com sucesso",
        delete_error: "Não foi possível excluir a regra",
        save: "Salvar",
        created: "Regra criada com sucesso",
        updated: "Regra atualizada com sucesso",
        save_error: "Não foi possível salvar a regra",
        load_error: "Não foi possível carregar a regra",
        select_type: "Selecione um tipo",
        select_level: "Selecione um nível"
    },
    general: {
        title: "Informações gerais",
        active_rule: "Regra ativa",
        rule_name: "Nome da regra",
        tenant: "Tenant",
        panel: "Painel",
        all_panels: "Todos os painéis do tenant",
        description: "Descrição"
    },
    programming: {
        title: "Programação",
        evaluation_mode: "Modo de avaliação",
        select_mode: "Selecione um modo",
        mode_immediate: "Janela",
        mode_delayed: "Depois",
        activation_time: "Hora de ativação",
        seconds: "Segundos",
        day_operation: "Dia de operação",
        all_days: "Todos os dias",
        business_days: "Dias úteis",
        business_days_and_saturdays: "Dias úteis e sábados",
        non_business_days_and_holidays: "Dias não úteis e feriados",
        applies_schedule: "Aplicar horário",
    },
    activation_condition: {
        add_condition: "Adicionar condição",
        title: "Condição de ativação",
        empty: "Você ainda não adicionou condições.",
        condition: "Condição",
        remove: "Remover",
        types: "Tipos",
        types_count: "{count} tipo(s)",
        device_type: "Tipo de dispositivo",
        details: "Detalhes",
        alarm_type: "Tipo de alarme",
        acronym: "Sigla",
        ocurrencies: "Ocorrências",
        devices: "Dispositivos",
        granular_condition: "Condição granular",
        general_condition: "Condição geral",
        granular: "Granular",
        general: "Geral",
        device: "Dispositivo",
        device_tag: "Tag do dispositivo",
        device_tag_placeholder: "É definido ao escolher o dispositivo",
        without_tag: "sem tag",
        cancel: "Cancelar",
        add: "Adicionar",
        needs_panel: "Selecione um painel na regra para escolher áreas e dispositivos.",
        area: "Área",
        zone: "Zona",
        area_without_zones: "Esta área não tem zonas",
        base_alarms: "Alarmes base",
        alarm_type_hint_granular: "Alarmes com base na tag do dispositivo",
        alarm_type_hint_general: "Qualquer tipo de alarme",
        occurrences_hint: "Aplica-se a todos os tipos desta condição",
        select_area: "Selecione uma área",
        select_zone: "Selecione uma zona",
        select_device: "Selecione um dispositivo",
        select_alarm_type: "Selecione um tipo de alarme",
        device_types: {
            area_zone: "Área - Zona",
            zone24h: "Zona 24h",
            door: "Porta",
            output: "Saída"
        },
    }
};